import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { usePatientMutations } from '@/features/patient-record/hooks/usePatientMutations';
import type { DemographicsViewModel } from '@/models/patient';

import { PhysicalChartCardShared } from './PhysicalChartCardShared';

interface PhysicalChartCardProps {
  readonly guid: string;
  readonly demographics: DemographicsViewModel;
}

/**
 * Patient (PERSON) physical-chart card — a thin wrapper over
 * {@link PhysicalChartCardShared} that supplies the person's chart and routes
 * saves through the demographics PUT (the chart rides on the full
 * demographics view model).
 */
export function PhysicalChartCard({
  guid,
  demographics,
}: PhysicalChartCardProps): ReactElement {
  const { t } = useTranslation();
  const { updateDemographics } = usePatientMutations(guid);

  return (
    <PhysicalChartCardShared
      parentType="PERSON"
      title={t('patient.demographics.physicalChart')}
      chart={demographics.physicalChart}
      saving={updateDemographics.isPending}
      onSave={(next) => {
        updateDemographics.mutate({ ...demographics, physicalChart: next });
      }}
    />
  );
}
